import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { PAGE_LIMIT } from "../../utils";

const DefectFilters = ({ loadData }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [codeList, setCodeList] = useState([]);

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          if (key === "description") {
            payload["code"] = filters[key].value;
          } else {
            payload[key] = filters[key].value;
          }
        } else {
          payload[key] = filters[key];
        }
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
        type: "defect",
      });
    } else {
      loadData({
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
        type: "defect",
      });
    }
  };

  const filterTypes = [
    { label: "Filter by Code", value: "code" },
    { label: "Filter by Description", value: "description" },
  ];
  const loadUserOptions = (type = "code") => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.TICKETS}/codes`, null, {
      type: "DEFECT",
    })
      .then((res) => {
        if (res.length) {
          const result = res?.map((ele) => ({
            label: type == "desc" ? ele?.description : ele.code,
            value: ele.code,
          }));
          setCodeList(result);
        }
      })
      .catch((err) => console.error(err));
  };

  const renderFilterInput = () => {
    switch (filterType) {
      case "code":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={codeList}
            placeholder="Search Code"
          />
        );
      case "description":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={codeList}
            placeholder="Search Description"
          />
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };
  useEffect(() => {
    if (filterType === "code") {
      loadUserOptions();
    }
    if (filterType === "description") {
      loadUserOptions("desc");
    }
  }, [filterType]);
  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default DefectFilters;
